import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const TotalDocQuantityCell: FC<GridCellProps> = (props) => (
  <GridCellBase {...props}>
    {props.dataItem.previousQty + props.dataItem.quantityReceived}
  </GridCellBase>
);

export default TotalDocQuantityCell;
